<template>
  <div class="lp-child-base basic-result" :style="styles">
    <block-title :target-info="targetInfo" :color-scheme="colorScheme" />
    <block-fortune-result :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" />
    <!-- <block-sns-share :target-info="targetInfo" :color-scheme="colorScheme" :result-share-words="resultShareWords" :result-share-url="resultShareUrl" :lp-id="lpId"/> -->
    <block-about-type :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" />
    <block-advice :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" :lp-id="lpId" pageLabel="basicresult" />
    <!-- <block-banner`
      v-if="showBanner"
      banner-pos="1"
      :ga-event-categ="`LP${lpId}basicresult-LINE-campaign-banner`"
      :lp-id="lpId"
      :campaign="bannerType"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      caption="鳳凰数術でもっと占うなら<br>まずはLINEで"
      class="block-banner--1"
    /> -->
    <!-- <block-title2 :target-info="targetInfo" :color-scheme="colorScheme" /> -->
    <!-- <block-fortune-input :target-info="targetInfo" :color-scheme="colorScheme" :action="action" :method="method" :token="token" :lp-id="lpId" pageLabel="basicresult" /> -->
    <!-- <block-mokuji :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" /> -->
    <!-- <block-lead-menu :target-info="targetInfo" :color-scheme="colorScheme" :subsc-url="subscUrl" /> -->
    <block-uranai-tv-desc
      :lp-id="lpId"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :preview-result-list="previewResultList"
      :subsc-url="subscUrl"
    >
      <block-three-years-later :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl" page="basicresult" />
      <block-baika-shineki :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl" page="basicresult" />
      <block-menus
        :lp-id="lpId"
        v-if="menusList.length"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :menu-list="menusList"
        :tab-list="menusTabList"
        :ga-event-categ="`LP${lpId}basicresult-paid-content-button`"
        page="basicresult"
        :subsc-url="subscUrl"
      />
    </block-uranai-tv-desc>

    <!-- <block-uranai-tv-short
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :subsc-url="subscUrl"
      :lp-id="lpId"
      page="basicresult"
      :is-individualed="true"
    /> -->
    <!-- <block-lead-subsc :target-info="targetInfo" :color-scheme="colorScheme" :subsc-url="subscUrl" /> -->
    <!-- <block-faq :color-scheme="colorScheme" :subsc-url="subscUrl" /> -->
    <!-- <line-campaign-message :target-info="targetInfo" :color-scheme="colorScheme"/> -->
    <div class="banner-wrap">
      <!--
      <block-banner
        v-if="showBanner"
        banner-pos="2"
        :ga-event-categ="`LP${lpId}basicresult-LINE-campaign-banner`"
        :lp-id="lpId"
        :campaign="bannerType"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :has-caption="false"
        class="block-banner--2"
      />
      -->
    </div>

  </div>
</template>

<script>
import BlockTitle from '@/utvStore/components/recommend/lp/blocks/BlockTitle'
import BlockFortuneResult from './blocks/BlockFortuneResult'
import BlockSnsShare from '@/utvStore/components/recommend/lp/blocks/BlockSnsShare'
import BlockMokuji from './blocks/BlockMokuji'
import BlockLeadMenu from './blocks/BlockLeadMenu'
//import BlockMenus from '@/utvStore/components/recommend/lp/blocks/BlockMenus'
import BlockMenus from './blocks/BlockMenus'
import BlockAboutType from './blocks/BlockAboutType'
import BlockLeadSubsc from '@/utvStore/components/recommend/lp/blocks/BlockLeadSubsc'
import BlockAdvice from './blocks/BlockAdvice'
import BlockTitle2 from '@/utvStore/components/recommend/lp/blocks/BlockTitle2'
import BlockFortuneInput from './blocks/BlockFortuneInput'
import BlockFaq from '@/utvStore/components/recommend/lp/blocks/BlockFaq'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'
import LineCampaignMessage from '@/utvStore/components/recommend/lp/partials/LineCampaignMessage'
import BlockUranaiTvShort from '@/utvStore/components/recommend/lp/blocks/BlockUranaiTvShort'
import BlockUranaiTvDesc from './blocks/BlockUranaiTvDesc'
import BlockThreeYearsLater from './blocks/BlockThreeYearsLater'
import BlockBaikaShineki from './blocks/BlockBaikaShineki'

export default {
  name: 'BasicResult',
  components: {
    BlockTitle,
    BlockFortuneResult,
    BlockSnsShare,
    BlockMokuji,
    BlockLeadMenu,
    BlockMenus,
    BlockAboutType,
    BlockLeadSubsc,
    BlockAdvice,
    BlockTitle2,
    BlockFortuneInput,
    BlockFaq,
    BlockBanner,
    LineCampaignMessage,
    BlockUranaiTvShort,
    BlockUranaiTvDesc,
    BlockThreeYearsLater,
    BlockBaikaShineki
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    menusTabList: {
      type: Array,
      default(){
        return []
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    resultData: Object,
    token: {
      type: String,
      default: '',
    },
    subscUrl: String,
    resultShareWords: {
      type: String,
      default: '',
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    previewResultList: {
      type: Array,
      default() { return [] },
    },
  },
  data(){
    return {
      action: `/recommend/lp/${this.lpId}/basic/action`,
      method: 'post'
    }
  },
  computed:{
    resultShareUrl(){
      return !!location.href ? location.href : ''
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
    showBanner() {
      return true
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_mess_bg: var(--mess-bg);

.btn-base {
  width: 100%;
  padding: 20px;
}
.lp-child-base {
  color: #32373F;
  .line-campaign-message {
    background: #fff;
  }
  .block-banner--1 {
    background: #fff;
    padding-top: 40px;
  }
  .block-banner--2 {
    padding-top: 0;
    padding-bottom: 60px;
    background: #FFFBE3;
  }
  .block-menu-base {
    background: #fff;
    /deep/ .tabed-menus-base {
      padding: 0;
    }
  }
  /deep/ {
    .block-title2 .block-title2__deco { left: unset; right: 0;}
    .subscr-preview-base {
      .baseButton__button {
        font-size: 16px;
      }
    }
  }
  .three-years-later {
    margin: 0 -20px;
    width: auto;
  }
  .baika-shineki {
    margin: 0 -20px;
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kurenotori/BasicResult.vue